import { Observable, PropertyChangedEventArgs } from "../../events";
import { Size3 } from "../../geometry";
export class Display {
    get propertyChangedObservable() {
        if (!this._propertyChangedObservable) {
            this._propertyChangedObservable = new Observable();
        }
        return this._propertyChangedObservable;
    }
    constructor(resolution) {
        this._resolution = Size3.FromSize(resolution);
    }
    get resolution() {
        return this._resolution;
    }
    resize(width, height, thickness) {
        if (this._resolution.width != width || this._resolution.height != height || this._resolution.depth != thickness) {
            if (this._propertyChangedObservable && this._propertyChangedObservable.hasObservers()) {
                const old = this._resolution;
                this._resolution = new Size3(width, height, thickness ?? this._resolution.depth);
                this._propertyChangedObservable.notifyObservers(new PropertyChangedEventArgs(this, old, this._resolution, "resolution"));
                return;
            }
            this._resolution.width = width;
            this._resolution.height = height;
            if (thickness) {
                this._resolution.depth = thickness;
            }
        }
    }
    dispose() {
        this._propertyChangedObservable?.clear();
    }
}
//# sourceMappingURL=tiles.display.js.map